export default __webpack_public_path__ + "static/media/loft.475e9cf1.jpg";